import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_GROWTH_BONUS_IMPRESSION_VALUE_UI = createFcmConfig('growth_bonus_impression_value_ui', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
